module.exports = __webpack_public_path__ + "static/media/halugen_kit_items-2x.28a8f8f8.png";